import AlertBannerSamples from '@ds/design-samples/AlertBannerSamples.vue';
import AvatarSamples from '@ds/design-samples/AvatarSamples.vue';
import BadgeSamples from '@ds/design-samples/BadgeSamples.vue';
import CheckboxSamples from '@ds/design-samples/CheckboxSamples.vue';
import CurlyQuotesSamples from '@ds/design-samples/CurlyQuotesSamples.vue';
import DialogSamples from '@ds/design-samples/DialogSamples.vue';
import DsAddressAutocompleteSearchSamples from '@ds/design-samples/DsAddressAutocompleteSearchSamples.vue';
import DsButtonSamples from '@ds/design-samples/DsButtonSamples/DsButtonSamples.vue';
import DsIconButtonSamples from '@ds/design-samples/DsButtonSamples/DsIconButtonSamples.vue';
import DsCardButtonSamples from '@ds/design-samples/DsCardButtonSamples.vue';
import DsCardCheckboxSamples from '@ds/design-samples/DsCardCheckboxSamples.vue';
import DsCardRadioSamples from '@ds/design-samples/DsCardRadioSamples.vue';
import DsCardSamples from '@ds/design-samples/DsCardSamples.vue';
import DsClosablePageSamples from '@ds/design-samples/DsClosablePageSamples.vue';
import DsComboboxSamples from '@ds/design-samples/DsComboboxSamples.vue';
import DsDataTableSamples from '@ds/design-samples/DsDataTableSamples.vue';
import DsDatePickerSamples from '@ds/design-samples/DsDatePickerSamples.vue';
import MaskedDisplaySamples from '@ds/design-samples/DsMaskedDisplaySamples.vue';
import DsMenuSamples from '@ds/design-samples/DsMenuSamples.vue';
import DsMoneyInputSamples from '@ds/design-samples/DsMoneyInputSamples.vue';
import DsMultiSelectSamples from '@ds/design-samples/DsMultiSelectSamples.vue';
import DsPhoneInputSamples from '@ds/design-samples/DsPhoneInputSamples.vue';
import DsPopoverSamples from '@ds/design-samples/DsPopoverSamples.vue';
import DsRadioSamples from '@ds/design-samples/DsRadioSamples.vue';
import DsSheetSamples from '@ds/design-samples/DsSheetSamples.vue';
import DsSideNavSamples from '@ds/design-samples/DsSideNavSamples.vue';
import DsSingleSelectSamples from '@ds/design-samples/DsSingleSelectSamples.vue';
import DsSortableListSamples from '@ds/design-samples/DsSortableListSamples.vue';
import DsTextInputSamples from '@ds/design-samples/DsTextInputSamples.vue';
import DsTextareaSamples from '@ds/design-samples/DsTextareaSamples.vue';
import DsToastSamples from '@ds/design-samples/DsToastSamples.vue';
import DsUploadSamples from '@ds/design-samples/DsUploadSamples.vue';
import DsZoomableCanvasSamples from '@ds/design-samples/DsZoomableCanvasSamples.vue';
import FoundationColors from '@ds/design-samples/FoundationColors.vue';
import GridBreakpoints from '@ds/design-samples/GridBreakpoints.vue';
import IconSample from '@ds/design-samples/IconSample.vue';
import PageLevelErrors from '@ds/design-samples/PageLevelErrors.vue';
import SpinnerSamples from '@ds/design-samples/SpinnerSamples.vue';
import TabSamples from '@ds/design-samples/TabSamples.vue';
import TagSamples from '@ds/design-samples/TagSamples.vue';
import TextDisplaySizes from '@ds/design-samples/TextDisplaySizes.vue';
import TooltipSamples from '@ds/design-samples/TooltipSamples.vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/design/side-nav',
        component: DsSideNavSamples,
    },
    {
        path: '/design/',
        redirect: '/design/colors',
    },
    {
        path: '/design/colors',
        component: FoundationColors,
    },
    {
        path: '/design/text',
        redirect: '/design/text/text-display',
        children: [
            {
                path: 'text-display',
                component: TextDisplaySizes,
            },
            {
                path: 'curly-quotes',
                component: CurlyQuotesSamples,
            },
        ],
    },
    {
        path: '/design/grid',
        component: GridBreakpoints,
    },
    {
        path: '/design/popover',
        component: DsPopoverSamples,
    },
    {
        path: '/design/datatable',
        component: DsDataTableSamples,
    },
    {
        path: '/design/icons',
        component: IconSample,
    },
    {
        path: '/design/spinners',
        component: SpinnerSamples,
    },
    {
        path: '/design/dialogs',
        component: DialogSamples,
    },
    {
        path: '/design/buttons',
        redirect: '/design/buttons/button',
        children: [
            {
                path: 'button',
                component: DsButtonSamples,
            },
            {
                path: 'icon-button',
                component: DsIconButtonSamples,
            },
        ],
    },
    {
        path: '/design/cards',
        redirect: '/design/cards/card',
        children: [
            {
                path: 'card',
                component: DsCardSamples,
            },
            {
                path: 'card-checkbox',
                component: DsCardCheckboxSamples,
            },
            {
                path: 'card-radio',
                component: DsCardRadioSamples,
            },
            {
                path: 'card-button',
                component: DsCardButtonSamples,
            },
        ],
    },
    {
        path: '/design/alert-banners',
        component: AlertBannerSamples,
    },
    {
        path: '/design/badges',
        component: BadgeSamples,
    },
    {
        path: '/design/tags',
        component: TagSamples,
    },
    {
        path: '/design/tabs',
        component: TabSamples,
    },
    {
        path: '/design/form-elements',
        redirect: '/design/form-elements/checkbox',
        children: [
            {
                path: 'checkbox',
                component: CheckboxSamples,
            },
            {
                path: 'radio',
                component: DsRadioSamples,
            },
            {
                path: 'text-input',
                component: DsTextInputSamples,
            },
            {
                path: 'money-input',
                component: DsMoneyInputSamples,
            },
            {
                path: 'textarea',
                component: DsTextareaSamples,
            },
            {
                path: 'multiselect',
                component: DsMultiSelectSamples,
            },
            {
                path: 'date-picker',
                component: DsDatePickerSamples,
            },
            {
                path: 'single-select',
                component: DsSingleSelectSamples,
            },
            {
                path: 'masked-display',
                component: MaskedDisplaySamples,
            },
            {
                path: 'upload-zone',
                component: DsUploadSamples,
            },
            {
                path: 'address-autocomplete-search',
                component: DsAddressAutocompleteSearchSamples,
            },
            {
                path: 'combobox',
                component: DsComboboxSamples,
            },
            {
                path: 'phone-input',
                component: DsPhoneInputSamples,
            },
        ],
    },
    {
        path: '/design/menu',
        component: DsMenuSamples,
    },
    {
        path: '/design/toasts',
        component: DsToastSamples,
    },
    {
        path: '/design/sheet',
        component: DsSheetSamples,
    },
    {
        path: '/design/tooltips',
        component: TooltipSamples,
    },
    {
        path: '/design/avatar',
        component: AvatarSamples,
    },
    {
        path: '/design/sortable-list',
        component: DsSortableListSamples,
    },
    {
        path: '/design/zoomable-canvas',
        component: DsZoomableCanvasSamples,
    },
    {
        path: '/design/page-level-errors',
        component: PageLevelErrors,
    },
    {
        path: '/design/closable-page',
        component: DsClosablePageSamples,
    },
];

export const buildSampleRouter = () =>
    createRouter({
        history: createWebHistory('/design'),
        routes,
    });
